/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */
/* eslint-disable */

import _get from 'lodash/get'
import queryString from 'query-string'
import UaParser from 'ua-parser-js'
import history from '../history'

import _isFunction from 'lodash/isFunction'
import WebTracker from '@supersoccer/web-tracker'
// import WebTracker from '../../../web-tracker'
import { setRuntimeVariable } from '@actions/runtime'

import { getActiveSubs } from '@source/lib/globalUtil'

// let firstRender = true;
let currentLocation = history.location

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    {
      path: '/privacy',
      load: () => import(/* webpackChunkName: 'privacy' */ './privacy'),
    },
    {
      path: '/search',
      load: () => import(/* webpackChunkName: 'search' */ './search'),
    },
    {
      path: '/accounts/login',
      load: () => import(/* webpackChunkName: 'login' */ './accounts/login'),
    },
    {
      path: '/accounts/otpVerification',
      load: () => import(/* webpackChunkName: 'otpverification' */ './accounts/otpVerification'),
    },
    {
      path: '/accounts/register',
      load: () => import(/* webpackChunkName: 'register' */ './accounts/register'),
    },
    {
      path: '/accounts/profile',
      load: () => import(/* webpackChunkName: 'profile' */ './accounts/profile'),
    },
    {
      path: '/standings',
      load: () => import(/* webpackChunkName: 'standings' */ './standings'),
    },
    {
      path: '/accounts/inbox',
      load: () => import(/* webpackChunkName: 'inbox-view' */ './accounts/inbox-view'),
      children: [
        {
          path: '/:inboxId/view',
        },
      ],
    },
    /** masa transisi forget-password untuk app start */
    {
      path: '/accounts/forgotPassword',
      load: () => import(/* webpackChunkName: 'forgotPassword' */ './accounts/forgot-password'),
    },
    /** masa transisi forget-password untuk app end */
    {
      path: '/accounts/forgot-password',
      load: () => import(/* webpackChunkName: 'forgot-password' */ './accounts/forgot-password'),
    },
    {
      path: '/accounts/reset-password',
      load: () => import(/* webpackChunkName: 'reset-password' */ './accounts/reset-password'),
    },
    {
      path: '/accounts/thankyou',
      load: () => import(/* webpackChunkName: 'thankyou' */ './accounts/thankyou'),
    },
    {
      path: '/accounts/bca-subscribe',
      load: () => import(/* webpackChunkName: 'bca-subscribe' */ './accounts/bca-subscribe'),
    },
    {
      path: '/accounts/login-bca',
      load: () => import(/* webpackChunkName: 'login-bca' */ './accounts/login-bca'),
    },
    {
      path: '/accounts/ordered',
      load: () => import(/* webpackChunkName: 'ordered' */ './accounts/ordered'),
    },
    {
      path: '/accounts/subscription-plan',
      load: () =>
        import(/* webpackChunkName: 'account-subscription-plan' */ './accounts/profile/content/subscription-plan'),
    },
    {
      path: '/accounts/checkout',
      load: () => import(/* webpackChunkName: 'checkout' */ './accounts/checkout'),
    },
    {
      path: '/accounts/user-data-input',
      load: () => import(/* webpackChunkName: 'user-data-input' */ './accounts/user-data-input'),
    },
    {
      path: '/accounts/consent',
      load: () => import(/* webpackChunkName: 'consent' */ './accounts/consent'),
    },
    // {
    //   path: '/accounts/compensation',
    //   load: () => import(/* webpackChunkName: 'compensation' */ './accounts/compensation'),
    // },
    {
      path: '/accounts/compensation-terms',
      load: () => import(/* webpackChunkName: 'compensation-terms' */ './accounts/compensation-terms'),
    },
    {
      path: '/accounts/add-emailphone',
      load: () => import(/* webpackChunkName: 'add-emailphone' */ './accounts/add-emailphone'),
    },
    {
      path: '/accounts/change-emailphone',
      load: () => import(/* webpackChunkName: 'change-emailphone' */ './accounts/change-emailphone'),
    },
    {
      path: '/system-info',
      load: () => import(/* webpackChunkName: 'system-info' */ './system-info'),
    },
    {
      path: '/terms',
      load: () => import(/* webpackChunkName: 'terms' */ './terms'),
    },
    {
      path: '/terms-conditions',
      load: () => import(/* webpackChunkName: 'terms-conditions' */ './terms-conditions'),
    },
    {
      path: '/terms/corona-care',
      load: () => import(/* webpackChunkName: 'corona-care' */ './corona-care'),
    },
    {
      path: '/get-app',
      load: () => import(/* webpackChunkName: 'get-app' */ './get-app'),
    },
    {
      path: '/get-app-desktop',
      load: () => import(/* webpackChunkName: 'get-app-desktop' */ './get-app-desktop'),
    },
    {
      path: '/promo',
      load: () => import(/* webpackChunkName: 'promo' */ './promo'),
    },
    {
      path: '/promo/details',
      load: () => import(/* webpackChunkName: 'promo-details' */ './promo/details'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/conditions',
      load: () => import(/* webpackChunkName: 'conditions' */ './conditions'),
    },
    {
      path: '/matches',
      load: () => import(/* webpackChunkName: 'matches' */ './matches'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/league-matches',
      load: () => import(/* webpackChunkName: 'league-matches' */ './league-matches'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/download-app',
      load: () => import(/* webpackChunkName: 'download-app' */ './download-app'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/categories',
      load: () => import(/* webpackChunkName: 'categories' */ './playlist'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/watch',
      load: () => import(/* webpackChunkName: 'watch' */ './watch'),
    },
    {
      path: '/libraries',
      load: () => import(/* webpackChunkName: 'libraries' */ './feature'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/events',
      load: () => import(/* webpackChunkName: 'events' */ './articlesv2'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/live-support',
      load: () => import(/* webpackChunkName: 'live-support' */ './live-support'),
    },
    {
      path: '/more',
      load: () => import(/* webpackChunkName: 'more' */ './more'),
    },
    {
      path: '/notifications',
      load: () => import(/* webpackChunkName: 'notifications' */ './notifications'),
    },
    {
      path: '/error/smart',
      load: () => import(/* webpackChunkName: 'smart' */ './error/smart'),
    },
    {
      path: '/payment/success',
      load: () => import(/* webpackChunkName: 'success' */ './payment/success'),
    },
    {
      path: '/payment/failed',
      load: () => import(/* webpackChunkName: 'failed' */ './payment/failed'),
    },
    {
      path: '/payment/waiting',
      load: () => import(/* webpackChunkName: 'waiting' */ './payment/waiting'),
    },
    {
      path: '/corona-donation',
      load: () => import(/* webpackChunkName: 'corona-donation' */ './corona-donation'),
    },
    {
      path: '/redeem/code-status',
      load: () => import(/* webpackChunkName: 'redeem-status' */ './redeem/redeem-status'),
    },
    {
      path: '/accounts/login-redeem',
      load: () => import(/* webpackChunkName: 'login-redeem' */ './accounts/login-redeem'),
    },
    {
      path: '/redeem/code',
      load: () => import(/* webpackChunkName: 'redeem' */ './redeem'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/mps',
      load: () => import(/* webpackChunkName: 'mps-subscription' */ './mps'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/browse',
      load: () => import(/* webpackChunkName: 'browse' */ './browse'),
    },
    {
      path: '/microsite/untuk-kamu',
      load: () => import(/* webpackChunkName: 'microsite' */ './microsite'),
    },
    {
      path: '/microsite/sofa-kuning',
      load: () => import(/* webpackChunkName: 'sofa-kuning' */ './sofa-kuningV2'),
    },
    {
      path: '/subscriptions-deactivate',
      load: () => import(/* webpackChunkName: 'subscriptions-deactivate' */ './subscriptions-deactivate'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/subscriptions-highlight',
      load: () => import(/* webpackChunkName: 'subscriptions-highlight' */ './subscriptions-highlight'),
    },
    {
      path: '/microsite/paket-mola-hbo',
      load: () => import(/* webpackChunkName: 'mola-hbo' */ './mola-hbo'),
    },
    {
      path: '/microsite/mola-kids-club',
      load: () => import(/* webpackChunkName: 'mola-kids-club' */ './mola-kids-club'),
    },
    {
      path: '/microsite/mola-kids-club/details',
      load: () => import(/* webpackChunkName: 'mola-kids-club-details' */ './mola-kids-club/details'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    {
      path: '/payment-link',
      load: () => import(/* webpackChunkName: 'payment-link' */ './payment-link'),
      children: [
        {
          path: '/:id',
        },
      ],
    },
    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next, store }) {
    const { configParams, runtime, user } = store.getState()
    /* Timeout runs the method in parallel upon changing routes */
    const isCoronaPageEnabled = _get(configParams, 'data.corona_page_enabled', false)

    // if (typeof document !== 'undefined') {
    //   if (!runtime.isMobile && currentLocation.pathname === '/accounts/subscriptionsList') {
    //     window.location = '/accounts/profile?tab=subscriptionPackage'
    //   }
    // }

    setTimeout(async () => {
      track(store)

      /** ini sementara saja sesuai bisnis, setiap pindah 5 page muncul sekali */
      const cp = '__coronaPageSessionId'
      const cpInterval = _get(configParams, 'data.corona_page_interval', 30 * 60)

      if (typeof document !== 'undefined' && isCoronaPageEnabled) {
        const activeCoronaSubs = getActiveSubs(_get(user, 'subscriptions', []), 'CoronaCare')

        /** sekedar info summary dari this.props.user.subscriptions */
        store.dispatch(setRuntimeVariable({ name: 'activeCoronaSubs', value: activeCoronaSubs || [] }))

        // if (activeCoronaSubs.length <= 0) {
        //   if (currentLocation.pathname === '/watch' && !runtime.hasCoronaPage && !document.cookie.includes(`${cp}`)) {
        //     store.dispatch(setRuntimeVariable({ name: 'hasCoronaPage', value: true }))
        //     document.cookie = `${cp}=999999; max-age=${cpInterval}; path=/;`
        //   }
        // }
      }
    })

    // Execute each child route until one of them return the result
    const route = await next()

    // ***TOOGLE ICON LIVE SUPPORT***
    const hideOffline = e => {
      const targetHide = document.getElementsByClassName('embeddedServiceHelpButton')[0]
      const labelChat = document.getElementById('headerTextLabel')
      if (labelChat && configParams.data.live_support_label) {
        labelChat.textContent = configParams.data.live_support_label
        targetHide.removeEventListener('DOMSubtreeModified', hideOffline)
      }
      // if (e.target.innerText === 'Offline') {
      //   // targetHide.style.visibility = 'hidden'
      // } else if (e.target.innerHTML === 'Online') {
      //   if (window) {
      //     if (window.location.pathname === '/') {
      //       targetHide.style.visibility = 'visible'
      //     }
      //   }
      // }
    }

    if (configParams.data) {
      if (configParams.data.live_support_enabled) {
        let elMessage = null
        setTimeout(function () {
          if (typeof document !== 'undefined') {
            const pathRoute = route.chunks[0]
            if (document.getElementsByClassName('embeddedServiceHelpButton')[0]) {
              elMessage = document.getElementsByClassName('message')[0]
              elMessage.addEventListener('DOMSubtreeModified', hideOffline)
              if (elMessage.innerHTML === 'Online') {
                document.getElementsByClassName('embeddedServiceHelpButton')[0].style.visibility = 'visible'
              }

              if (pathRoute === 'live-support') {
                if (window.App.isMobile) {
                  document.getElementsByClassName('embeddedServiceHelpButton')[0].style.visibility = 'visible'
                  let _el = document.getElementsByClassName('helpButton')[0]
                  _el.style.left = '44.5vw'
                  _el.style.right = '-50vw'
                  _el.style.top = '50vh'
                  _el.style.visibility = 'visible'
                }
              }
            }
          }
        }, 3000)
      }
    }

    // ***END OF TOOTGLE ICON LIVE SUPPORT***

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Untitled Page'}`
    route.description = route.description || ''
    return route
  },
}

function addListenerMulti(el, s, fn) {
  s.split(' ').forEach(e => el.addEventListener(e, fn, false))
}

const track = async store => {
  if (__BROWSER__) {
    const { location } = window
    // Parse Current URL
    const { search, pathname } = window.location
    const urlParams = queryString.parse(search)
    // Get & Parse UA
    const UA = new UaParser()
    UA.setUA(navigator.userAgent)

    // Try get user_id & subs
    const user = store.getState().user

    // get pubsub url from config params
    const configParams = store.getState().configParams
    const pubsubConfig = configParams && configParams.data && configParams.data.pubsub ? configParams.data.pubsub : null

    // Check if current path is in search page
    const inSearchPage = currentLocation.pathname === '/search' || currentLocation.pathname === '/get-app'

    // get the token
    // const token = await tracker.getOrCreateToken()
    // Post to ds-feeder if there's token && not in search page
    if (!inSearchPage) {
      const payload = {
        window,
        userData: user,
        event: 'event_pages',
        currentLocation: history.location,
        document: document,
      }

      WebTracker.trackEvent({ data: payload, pubsubConfig })
    }
    //tracker.sendPubSub(payload, token)
    if (pathname.includes('watch')) {
      if (urlParams.v) {
        let checkEncoded = urlParams.v.split('u0026')
        let videoId = checkEncoded.length > 0 && checkEncoded[0]
        // if (videoId.length === 10) {
        let checkRegex = RegExp('^[a-zA-Z0-9\\-]*$')
        let isValidId = checkRegex.test(videoId)
        if (isValidId) {
          if (!inSearchPage) {
            const payload = {
              window,
              videoData: {
                id: videoId,
              },
              userData: user,
              document: document,
              currentLocation: history.location,
              event: 'event_videos',
            }
            WebTracker.trackEvent({ data: payload, pubsubConfig })
          } //tracker.sendPubSub(payload, token)
        }
        // }
      }
    }

    // HOTFIX need to find a way to get refferer in react
    currentLocation = location
  }
}

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  })
}

export default routes
